import Vue from 'vue';
import VueRouter from 'vue-router';

import App from './App.vue';

import Home from './components/Home.vue';
import ListGames from './components/ListGames.vue';
import Play from './components/Play.vue';
import Run from './components/Run.vue';
import store from './store';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/play/:game_id?',
      name: 'play',
      component: Play,
      key: '$route.fullPath'
    },
    {
      path: '/run/:game_id/:lang?',
      name: 'run',
      component: Run,
      key: '$route.fullPath'
    }
  ]
});

const app = new Vue({
  router,
  store,
  render: function(createElement) {
    return createElement(App);
  }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js